<template>
  <div class="tournament-round">
    <loading-state :state="state"></loading-state>
    <div v-if="tournament">
      <h2>{{tournament.name}} - {{round.name}}</h2>

      <section>
        <h3>Matches</h3>
        <div class="sub-content">
            <div class="item compact link" v-for="match in round.matches" :key="match.info.key">
                <football-match-mini :match="match"></football-match-mini>
            </div>
        </div>
      </section>

      <section v-if="tournament.pointing_system == 'tournament'">
        <h3>Match days</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag" v-for="around in tournament.rounds" :key="around.key">
                <router-link class="clean" :to="{name:'tournamentRound', params:{key:tournamentKey, roundkey:around.key}}">{{around.name}}</router-link>
              </span>
            </div>
          </div>
        </div>
      </section>
      <section v-else>
        <h3>Rounds</h3>
        <div class="sub-content">
          <div class="item compact link" v-for="around in tournament.rounds" :key="around.key">
            <div>
              <router-link class="clean" :to="{name:'tournamentRound', params:{key:tournamentKey, roundkey:around.key}}">{{around.name}}</router-link>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import { FootballTournament } from '@/models/tournament'
import { DataState, AppState } from '@/state'

export default {
  name: 'tournament-round',
  data () {
    return {
      tournamentKey: this.$route.params.key,
      roundKey: this.$route.params.roundkey,
      tournament: null,
      round: null,
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.roundkey !== from.params.roundkey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.tournamentKey = this.$route.params.key
      this.roundKey = this.$route.params.roundkey
      const newTitle = 'loading...'
      AppState.updateActivePage(`tournament_${this.tournamentKey}_round_${this.roundKey}`)
      AppState.updateTitles(newTitle, newTitle)

      FootballTournament.fetchRound(this.tournamentKey, this.roundKey).then(round => {
        this.round = round
        console.log('Rou', round)
        return FootballTournament.fetch(this.tournamentKey).then(tournament => {
          const newTitle = `${tournament.name} - ${round.name}`
          AppState.updateTitles(newTitle, newTitle)
          this.tournament = tournament
          this.state.changeToLoaded()
        })
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.tournament = null
      this.round = null
    },
    refreshView () {

    }
  }
}
</script>
